import React from "react";
import { createBrowserRouter, Outlet, RouterProvider, Navigate } from "react-router-dom";
import SuperAdminRoute from "../../components/SuperAdminRoute";
import SubscriptionRoute from "../../components/SubscriptionRoute";
import Signup from "../../usecases/Signup";
import ProfilePage from "../../usecases/ProfilePage";
import Dashboard from "../../usecases/Dashboard";
import { Suspense } from "react";
import Home from "../../usecases/Dashboard/HRModule/Home";
import ManageStaff from "../../usecases/Dashboard/HRModule/ManageStaff";
import ProfileChanges from "../../usecases/Dashboard/HRModule/ProfileChanges";
import AdditionalInfo from "../../usecases/Dashboard/HRModule/Employees/AddNewEmployee/AdditionalInfo";
import AddNewEmployee from "../../usecases/Dashboard/HRModule/Employees/AddNewEmployee";
import Login from "../../usecases/Login";
import ViewEmployee from "../../usecases/Dashboard/HRModule/ViewEmployee";
import EditEmployee from "../../usecases/Dashboard/HRModule/Employees/EditEmployee";
import Attendance from "../../usecases/Dashboard/HRModule/Attendance";
import Deduction from "../../usecases/Dashboard/HRModule/Deductions/DeductionHome";
import Loan from "../../usecases/Dashboard/HRModule/Loan/LoanHome";
import Pension from "../../usecases/Dashboard/HRModule/Pension/PensionHome";
import LoanView from "../../usecases/Dashboard/HRModule/Loan/LoanView";
import DeductionView from "../../usecases/Dashboard/HRModule/Deductions/DeductionView";
import PayrollPayslips from "../../usecases/Dashboard/HRModule/PayrollPayslip"
import LeaveManagement from "../../usecases/Dashboard/HRModule/LeaveManagement";
import ViewLeaveManagement from "../../usecases/Dashboard/HRModule/ViewLeaveManagement";
import Recruitment from "../../usecases/Dashboard/HRModule/Recruitment";
import ViewRecruitment from "../../usecases/Dashboard/HRModule/ViewRecruitment";
import RolesAndPermissions from "../../usecases/Dashboard/HRModule/RolesAndPermissions";
import ModifyRolesPermissions from "../../usecases/Dashboard/HRModule/ModifyRolesPermissions"
import TimesheetManagement from "../../usecases/Dashboard/HRModule/Timesheet";
import PayrollModule from "../../usecases/Dashboard/HRModule/PayrollModule";
import PayrollSalarySlip from "../../usecases/Dashboard/HRModule/PayrollSalary";
import SalaryManagement from "../../usecases/Dashboard/HRModule/Salary/View";
import SalaryEmployeePage from "../../usecases/Dashboard/HRModule/Salary/Home";
import CreateRecruitment from "../../usecases/Dashboard/HRModule/CreateRecruitment";
import CompanyInfo from "../../usecases/Signup/companyInfo";
import ViewSalaryPayslip from "../../usecases/Dashboard/HRModule/Salary/ViewSalaryPayslip";
import SalaryEdit from "../../usecases/Dashboard/HRModule/Salary/SalaryEdit";
import PayslipGeneration from "../../usecases/Dashboard/HRModule/PayslipGeneration";
import CreatePayroll from "../../usecases/Dashboard/HRModule/CreatePayroll";
import AccountSettings from "../../usecases/AccountSettings";
import CompanyList from "../../usecases/AccountSettings/CompanyList";
import Items from "../../usecases/Dashboard/AccountingModule/Items";
import AddNewItem from "../../usecases/Dashboard/AccountingModule/AddNewItem";
import EditItem from "../../usecases/Dashboard/AccountingModule/EditItem";
import Supplier from "../../usecases/Dashboard/AccountingModule/Supplier/SupplierHome";
import AddNewSupplier from "../../usecases/Dashboard/AccountingModule/Supplier/AddNewSupplier";
import EditSupplier from "../../usecases/Dashboard/AccountingModule/Supplier/EditSupplier";
import Purchase from "../../usecases/Dashboard/AccountingModule/Purchase/PurchaseHome";
import SupplierDetail from "../../usecases/Dashboard/AccountingModule/Supplier/SupplierDetails";
import CreateBill from "../../usecases/Dashboard/AccountingModule/Supplier/CreateBill";
import EditBill from "../../usecases/Dashboard/AccountingModule/Supplier/EditBill";
import ViewBill from "../../usecases/Dashboard/AccountingModule/Supplier/BillView";
import Project from "../../usecases/Dashboard/HRModule/Project";
import SuperAdmin from "../../usecases/SuperAdminPage";
import ViewItem from "../../usecases/Dashboard/AccountingModule/ViewItem";
import BankHome from "../../usecases/Dashboard/AccountingModule/Bank/BankHome";
import AddBank from "../../usecases/Dashboard/AccountingModule/Bank/AddBank";
import ImportStatement from "../../usecases/Dashboard/AccountingModule/Bank/ImportStatement";
import EditBank from "../../usecases/Dashboard/AccountingModule/Bank/EditBank";
import Customers from "../../usecases/Dashboard/AccountingModule/Customer/ManageCustomer";
import AddNewCustomer from "../../usecases/Dashboard/AccountingModule/Customer/AddNewCustomer";
import EditCustomer from "../../usecases/Dashboard/AccountingModule/Customer/EditCustomer";
import CustomerStatement from "../../usecases/Dashboard/AccountingModule/Customer/CustomerStatement";
import SalesReport from "../../usecases/Dashboard/AccountingModule/Customer/SalesReport";
import SalesList from "../../usecases/Dashboard/AccountingModule/Customer/SalesList";
import NewSalesOrder from "../../usecases/Dashboard/AccountingModule/Customer/NewSalesOrder";
import Invoice from "../../usecases/Dashboard/AccountingModule/Invoice/InvoiceHome";
import ViewInvoice from "../../usecases/Dashboard/AccountingModule/Invoice/InvoiceView";
import CreateInvoice from "../../usecases/Dashboard/AccountingModule/Invoice/CreateInvoice";
import EditInvoice from "../../usecases/Dashboard/AccountingModule/Invoice/EditInvoice";
import AddPurchase from "../../usecases/Dashboard/AccountingModule/Purchase/PurchaseCreate";
import CreateInvoices from "../../usecases/Dashboard/AccountingModule/Customer/CreateInvoice";
import AdditionalInformation from "../../usecases/AccountSettings/AdditionalInformation";
import ProfitLossStatement from "../../usecases/Dashboard/AccountingModule/Profit&LossStatement";
import BalanceSheet from "../../usecases/Dashboard/AccountingModule/BalanceSheet";
import Reports from "../../usecases/Dashboard/HRModule/Reports";
import FinancialStatement from "../../usecases/Dashboard/AccountingModule/Reports/FinancialStatement";
import StatementGenerate from "../../usecases/Dashboard/AccountingModule/StatementGenerate";
import CashFlowStatement from "../../usecases/Dashboard/AccountingModule/CashFlowStatement";
import Allowance from "../../usecases/Allowance";
import ControlCentre from "../../usecases/ControlCentre";
import FinancialYear from "../../usecases/FinancialYear";
import Subscription from "../../usecases/Subscription";
import Credits from "../../usecases/Credits";
import Rebate from "../../usecases/Rebate";
import Fringe from "../../usecases/Fringe";
import Leave from "../../usecases/Leave";
import TaxTable from "../../usecases/TaxTable";
import Threshold from "../../usecases/Threshold";
import Uif from "../../usecases/Uif";
import SDL from "../../usecases/SDL";
import Pensionfild from "../../usecases/Pension";
import Commisson from "../../usecases/Dashboard/HRModule/Commisson";
import Travelallowances from "../../usecases/Dashboard/HRModule/Travelallowances";
import ViewCommission from "../../usecases/Dashboard/HRModule/ViewCommission";
import ViewTravelAllowances from "../../usecases/Dashboard/HRModule/ViewTravelallowances";
import Contribution from "../../usecases/Contribution";
import SubAdmin from "../../usecases/SubAdmin";
import SubAdminCreate from "../../usecases/SubAdmin/CreateEdit";
import PayrollSalaryList from "../../usecases/Dashboard/HRModule/PayrollSalaryList";
import PurchaseEdit from "../../usecases/Dashboard/AccountingModule/Purchase/PurchaseEdit";
import UniversalTax from "../../usecases/UniversalTax";
import PurchaseDetails from "../../usecases/Dashboard/AccountingModule/Purchase/PurchaseDetails";
import Expense from "../../usecases/Dashboard/AccountingModule/Expense";
import AddExpense from "../../usecases/Dashboard/AccountingModule/AddExpense";
import ViewExpense from "../../usecases/Dashboard/AccountingModule/ViewExpense";
import OtherIncome from "../../usecases/Dashboard/AccountingModule/OtherIncome";
import AddOtherIncome from "../../usecases/Dashboard/AccountingModule/OtherIncome/AddOtherIncome";
import ViewOtherIncome from "../../usecases/Dashboard/AccountingModule/OtherIncome/ViewOtherIncome";
import SpecialPrice from "../../usecases/Dashboard/AccountingModule/SpecialPrice";
import ViewBank from "../../usecases/Dashboard/AccountingModule/Bank/ViewBank";
import UpdateSpecialPrice from "../../usecases/Dashboard/AccountingModule/SpecialPrice/UpdateSpecialPrice";
import StaffPage from "../../usecases/Dashboard/AccountingModule/StaffPage";
import AddNewStaff from "../../usecases/Dashboard/AccountingModule/StaffPage/AddNewStaff";
import EditStaff from "../../usecases/Dashboard/AccountingModule/StaffPage/EditStaff";
import AccountTransaction from "../../usecases/Dashboard/AccountingModule/Bank/AccountTransaction";
import AccountReconciliation from "../../usecases/Dashboard/AccountingModule/Bank/AccountReconciliation";
import AllReconciliationList from "../../usecases/Dashboard/AccountingModule/Bank/AccountReconciliation/allReconciliationList";
import ReconciliationDetails from "../../usecases/Dashboard/AccountingModule/Bank/AccountReconciliation/reconciliationDetails";
import Quotes from "../../usecases/Dashboard/AccountingModule/Quotes/QuotesHome";
import ViewQuotes from "../../usecases/Dashboard/AccountingModule/Quotes/QuotesView";
import QuotesCreate from "../../usecases/Dashboard/AccountingModule/Quotes/QuotesCreate";
import QuotesEdit from "../../usecases/Dashboard/AccountingModule/Quotes/QuotesEdit";
import RecurringTemplate from "../../usecases/Dashboard/AccountingModule/Invoice/RecurringTemplate";
import CreateNotes from "../../usecases/Dashboard/AccountingModule/Customer/Notes/CreateNotes";
import EditNotes from "../../usecases/Dashboard/AccountingModule/Customer/Notes/EditNotes";
import EditRecurringTemplate from "../../usecases/Dashboard/AccountingModule/Invoice/EditRecurringTemplate";
import NotesHome from "../../usecases/Dashboard/AccountingModule/Customer/Notes/NotesHome";
import ViewNotesPage from "../../usecases/Dashboard/AccountingModule/Customer/Notes/ViewNotes";
import HomeSales from "../../usecases/Dashboard/AccountingModule/Customer/SalesOrder/HomeSales";
import CreateSales from "../../usecases/Dashboard/AccountingModule/Customer/SalesOrder/CreateSales";
import EditSales from "../../usecases/Dashboard/AccountingModule/Customer/SalesOrder/EditSales";
import ViewSales from "../../usecases/Dashboard/AccountingModule/Customer/SalesOrder/ViewSales";
import CreateNewInvoicePage from "../../entities/DashboardPage/AccountingModule/Customer/SalesOrder/CreateNewInvoice";
import PurchaseSupplierList from "../../usecases/Dashboard/AccountingModule/Supplier/PurchaseSupplierList";
import ViewPurchase from "../../usecases/Dashboard/AccountingModule/Purchase/PurchaseView";
import PurchaseOrderEdit from "../../usecases/Dashboard/AccountingModule/Purchase/PurchaseOrderEdit";
import PurchaseOrderView from "../../usecases/Dashboard/AccountingModule/Purchase/PurchaseOrderView";
import ConvertToBill from "../../entities/DashboardPage/AccountingModule/Purchase/ConvertToBill";
import AssetsHome from "../../usecases/Dashboard/AccountingModule/Customer/AssetsManagement/AssetsHome";
import AssetsCreate from "../../usecases/Dashboard/AccountingModule/Customer/AssetsManagement/AssetsCreate";
import AssetsView from "../../usecases/Dashboard/AccountingModule/Customer/AssetsManagement/AssetsView";
import Settings from "../../usecases/Settings";
import OrganizeProfile from "../../usecases/Settings/OrganizeProfile";
import Branding from "../../usecases/Settings/Branding";
import EmployeeView from "../../usecases/Dashboard/HRModule/Employees/ViewEmployee";
import UserManagement from "../../usecases/SuperAdminPage/UserManagement";
import CreateNewClient from "../../usecases/SuperAdminPage/CreateNewClient";
import ViewClient from "../../usecases/SuperAdminPage/ViewClient";
import PlanManagement from "../../usecases/SuperAdminPage/PlanManagement";
import CreateNewPlan from "../../usecases/SuperAdminPage/CreateNewPlan";
import TopupManagement from "../../usecases/SuperAdminPage/TopupManagement";
import CreateNewTopup from "../../usecases/SuperAdminPage/CreateNewTopup";
import TopupSales from "../../usecases/SuperAdminPage/TopupSales";
import Topups from "../../usecases/Topups";
import Plan from "../../usecases/Plan";
import TermsAndConditions from "../../entities/TermsAndConditions";
import ForgotPassword from "../../usecases/ForgotPassword";
import ResetPassword from "../../usecases/ResetPassword";
import VerifyEmail from "../../usecases/VerifyEmail";
import VerifyToken from "../../usecases/VerifyEmail/VerifyToken";
import VerifyPhone from "../../usecases/VerifyPhone";

import CommunicationCenter from "../../usecases/SuperAdminPage/CommunicationCenter";
import NotificationBroadcast from "../../usecases/SuperAdminPage/NotificationBroadcast";
import RegionalAnalytics from "../../usecases/SuperAdminPage/RegionalAnalytics";
import TransitionAlerts from "../../utils/Alert";
import SubscriptionAlert from "../../utils/Alert/SubscriptionAlert";
import PaymentReturnHandler from "../../utils/Alert/PaymentReturnHandler";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <TransitionAlerts />
        <SubscriptionAlert />
        <PaymentReturnHandler />
        <Outlet />
      </>
    ),
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        path: "/signup",
        element: <Signup />,
      },
      {
        path: "/companyInfo",
        element: <CompanyInfo />,
      },
      {
        path: "/planManagement",
        element: <Plan />,
      },
      {
        path: "/terms",
        element: <TermsAndConditions mode="terms" />,
      },
      {
        path: "/privacy-policy",
        element: <TermsAndConditions mode="privacy" />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/reset-password/:token",
        element: <ResetPassword />,
      },
      {
        path: "/verify-email",
        element: <VerifyEmail />,
      },
      {
        path: "/verify-email/:token",
        element: <VerifyToken />,
      },
      {
        path: "/verify-phone",
        element: <VerifyPhone />,
      },

      {
        path: "dashboard",
        element: (
          <Dashboard>
            <Suspense>
              <Outlet />
            </Suspense>
          </Dashboard>
        ),
        children: [
          { element: <Home />, index: true },
          { path: "manageStaff", element: <ManageStaff /> },
          { path: "profileChanges", element: <ProfileChanges /> },
          { path: "additionalInfo", element: <AdditionalInfo /> },
          { path: "profile", element: <ProfilePage /> },
          { path: "topups", element: <Topups /> },
          { path: "attendance", element: <Attendance /> },
          { path: "leaveManagement", element: <LeaveManagement /> },
          { path: "deduction", element: <Deduction /> },
          { path: "viewDeduction", element: <DeductionView /> },
          { path: "loan", element: <Loan /> },
          { path: "viewLoan", element: <LoanView /> },
          { path: "pension", element: <Pension /> },
          { path: "viewLeaveManagement", element: <ViewLeaveManagement /> },
          { path: "manageStaff/addNew", element: <AddNewEmployee /> },
          { path: "manageStaff/viewEmployee", element: <EmployeeView /> },
          { path: "manageStaff/editProfile", element: <EditEmployee /> },
          { path: "reports", element: <Reports /> },
          { path: "recruitment", element: <Recruitment /> },
          { path: "viewRecruitment", element: <ViewRecruitment /> },
          { path: "recruitment/createRecruitment", element: <CreateRecruitment /> },
          { path: "rolesAndPermissions", element: <RolesAndPermissions /> },
          { path: "modifyRolePermission", element: <ModifyRolesPermissions /> },
          { path: "timesheet", element: <TimesheetManagement /> },
          { path: "payrollModule", element: <PayrollModule /> },
          { path: "payrollModule/addPayroll", element: <CreatePayroll /> },
          { path: "payrollSalary", element: <PayrollSalarySlip /> },
          { path: "payrollPayslips", element: <PayrollPayslips /> },
          { path: "salaryEmployeePage", element: <SubscriptionRoute feature="Salary Management"><SalaryEmployeePage /></SubscriptionRoute> },
          { path: "salaryManagement", element: <SubscriptionRoute feature="Salary Management"><SalaryManagement /></SubscriptionRoute> },
          { path: "viewSalaryPayslip", element: <SubscriptionRoute feature="Salary Management"><ViewSalaryPayslip /></SubscriptionRoute> },
          { path: "salaryEdit", element: <SubscriptionRoute feature="Salary Management"><SalaryEdit /></SubscriptionRoute> },
          { path: "payslipGeneration", element: <PayslipGeneration /> },
          { path: "accountSettings", element: < AccountSettings /> },
          { path: "companyList", element: <CompanyList /> },
          { path: "items", element: < Items /> },
          { path: "addNewItem", element: < AddNewItem /> },
          { path: "editItem", element: < EditItem /> },
          { path: "viewItem", element: < ViewItem /> },
          { path: "supplier", element: < Supplier /> },
          { path: "addNewSupplier", element: < AddNewSupplier /> },
          { path: "editSupplier", element: < EditSupplier /> },
          { path: "purchase", element: < Purchase /> },
          { path: "purchaseOrder", element: < PurchaseSupplierList /> },
          { path: "addPurchase", element: < AddPurchase /> },
          { path: "viewPurchase", element: < ViewPurchase /> },
          { path: 'purchaseOrderEdit', element: <PurchaseOrderEdit /> },
          { path: 'purchaseOrderView', element: <PurchaseOrderView /> },
          { path: "editPurchase", element: < PurchaseEdit /> },
          { path: "supplierDetails", element: < SupplierDetail /> },
          { path: "billView", element: <PurchaseDetails /> },
          { path: "createBill", element: < CreateBill /> },
          { path: "editBill", element: < EditBill /> },
          { path: "viewBill", element: < ViewBill /> },
          { path: "bankHome", element: < BankHome /> },
          { path: "addBank", element: < AddBank /> },
          { path: "importStatement", element: < ImportStatement /> },
          { path: "accountTransaction", element: < AccountTransaction /> },
          { path: "accountReconciliationList", element: < AllReconciliationList /> },
          { path: "reconciliationDetails", element: < ReconciliationDetails /> },
          { path: "accountReconciliation", element: < AccountReconciliation /> },
          { path: "editBank", element: < EditBank /> },
          { path: "Projects", element: <Project /> },
          { path: "customer", element: <Customers /> },
          { path: "addNewCustomer", element: < AddNewCustomer /> },
          { path: "editCustomer", element: < EditCustomer /> },
          { path: "customerStatement", element: < CustomerStatement /> },
          { path: "salesReport", element: < SalesReport /> },
          { path: "salesList", element: < SalesList /> },
          { path: "newSalesOrders", element: < NewSalesOrder /> },
          { path: "cashFlowStatement", element: < CashFlowStatement /> },
          { path: "invoice", element: < Invoice /> },
          { path: "createInvoice", element: < CreateInvoice /> },
          { path: "editInvoice", element: < EditInvoice /> },
          { path: "viewInvoice", element: < ViewInvoice /> },
          { path: "recurringTemplate", element: < RecurringTemplate /> },
          { path: "editRecurringTemplate", element: < EditRecurringTemplate /> },
          { path: "createInvoices", element: < CreateInvoices /> },
          { path: "additionalInformation", element: < AdditionalInformation /> },
          { path: "profit&LossStatement", element: < ProfitLossStatement /> },
          { path: "balanceSheet", element: < BalanceSheet /> },
          { path: "financialStatement", element: < FinancialStatement /> },
          { path: "statementGenerate", element: < StatementGenerate /> },
          { path: "superAdmin", element: <SuperAdminRoute><SuperAdmin /></SuperAdminRoute> },
          { path: "ControlCentre", element: <SuperAdminRoute><ControlCentre /></SuperAdminRoute> },
          { path: "FinancialYear", element: <SuperAdminRoute><FinancialYear /></SuperAdminRoute> },
          { path: "Subscription", element: <SuperAdminRoute><Subscription /></SuperAdminRoute> },
          { path: "Allowance", element: <SuperAdminRoute><Allowance /></SuperAdminRoute> },
          { path: "Fringe", element: <SuperAdminRoute><Fringe /></SuperAdminRoute> },
          { path: "Pensionfild", element: <SuperAdminRoute><Pensionfild /></SuperAdminRoute> },
          { path: "Leave", element: <SuperAdminRoute><Leave /></SuperAdminRoute> },
          { path: "TaxTable", element: <SuperAdminRoute><TaxTable /></SuperAdminRoute> },
          { path: "Credits", element: <SuperAdminRoute><Credits /></SuperAdminRoute> },
          { path: "Rebate", element: <SuperAdminRoute><Rebate /></SuperAdminRoute> },
          { path: "Threshold", element: <SuperAdminRoute><Threshold /></SuperAdminRoute> },
          { path: "Uif", element: <SuperAdminRoute><Uif /></SuperAdminRoute> },
          { path: "SDL", element: <SuperAdminRoute><SDL /></SuperAdminRoute> },
          { path: "commisson", element: < Commisson /> },
          { path: "travelAllowances", element: < Travelallowances /> },
          { path: "viewCommission", element: <ViewCommission /> },
          { path: "viewTravelAllowances", element: <ViewTravelAllowances /> },
          { path: "Contribution", element: <SuperAdminRoute><Contribution /></SuperAdminRoute> },
          { path: "userManagement", element: <SuperAdminRoute><UserManagement /></SuperAdminRoute> },
          { path: "communicationCenter", element: <CommunicationCenter /> },
          { path: "notificationBroadcast", element: <SuperAdminRoute><NotificationBroadcast /></SuperAdminRoute> },
          { path: "regionalAnalytics", element: <SuperAdminRoute><RegionalAnalytics /></SuperAdminRoute> },
          { path: "userManagement/createClient", element: <SuperAdminRoute><CreateNewClient /></SuperAdminRoute> },
          { path: "userManagement/edit/:id", element: <SuperAdminRoute><CreateNewClient /></SuperAdminRoute> },
          { path: "userManagement/viewClient/:id", element: <SuperAdminRoute><ViewClient /></SuperAdminRoute> },
          { path: "planManagement", element: <SuperAdminRoute><PlanManagement /></SuperAdminRoute> },
          { path: "planManagement/createPlan", element: <SuperAdminRoute><CreateNewPlan /></SuperAdminRoute> },
          { path: "planManagement/edit/:id", element: <SuperAdminRoute><CreateNewPlan /></SuperAdminRoute> },
          { path: "topupManagement", element: <SuperAdminRoute><TopupManagement /></SuperAdminRoute> },
          { path: "topupManagement/createTopup", element: <SuperAdminRoute><CreateNewTopup /></SuperAdminRoute> },
          { path: "topupManagement/edit/:id", element: <SuperAdminRoute><CreateNewTopup /></SuperAdminRoute> },
          { path: "topupManagement/sales", element: <SuperAdminRoute><TopupSales /></SuperAdminRoute> },
          { path: "sub-admin", element: <SuperAdminRoute><SubAdmin /></SuperAdminRoute> },
          { path: "sub-admin/create", element: <SuperAdminRoute><SubAdminCreate /></SuperAdminRoute> },
          { path: "sub-admin/edit/:id", element: <SuperAdminRoute><SubAdminCreate /></SuperAdminRoute> },
          { path: "PayrollSalaryList", element: <PayrollSalaryList /> },
          { path: "UniversalTax", element: <UniversalTax /> },
          { path: "expense", element: < Expense /> },
          { path: "addExpense", element: <AddExpense /> },
          { path: "viewExpense", element: <ViewExpense /> },
          { path: "otherIncome", element: <OtherIncome /> },
          { path: "addOtherIncome", element: <AddOtherIncome /> },
          { path: "viewOtherIncome", element: <ViewOtherIncome /> },
          { path: "specialPrice", element: <SpecialPrice /> },
          { path: "viewBankTransactions", element: <ViewBank /> },
          { path: "updateSale", element: <UpdateSpecialPrice /> },
          { path: "Staff", element: <StaffPage /> },
          { path: "addNewStaff", element: <AddNewStaff /> },
          { path: "editStaff", element: <EditStaff /> },
          { path: "quotes", element: <Quotes /> },
          { path: "quotes/new", element: <QuotesCreate /> },
          { path: "editQuote", element: <QuotesEdit /> },
          { path: "viewQuote", element: <ViewQuotes /> },
          { path: "notesHome", element: <NotesHome /> },
          { path: "viewNotes", element: < ViewNotesPage /> },
          { path: "notesHome/editNotes", element: <EditNotes /> },
          { path: "notesHome/createNotes", element: <CreateNotes /> },
          { path: 'salesHome', element: <HomeSales /> },
          { path: "salesHome/createSales", element: < CreateSales /> },
          { path: "salesHome/editSales", element: < EditSales /> },
          { path: "salesHome/viewSales", element: < ViewSales /> },
          { path: 'salesHome/createNewInvoice', element: <CreateNewInvoicePage /> },
          { path: 'ConvertToBill', element: <ConvertToBill /> },
          { path: 'assetsHome', element: <AssetsHome /> },
          { path: 'assetsHome/assetsCreate', element: <AssetsCreate /> },
          { path: 'assetsHome/assetsView', element: <AssetsView /> },
          { path: 'settings', element: <Settings /> },
          { path: 'settings/organizeProfile', element: <OrganizeProfile /> },
          { path: 'settings/branding', element: <Branding /> },
        ],
      },
    ],
  },
]);

const Router = () => {
  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}

export default Router;
